import { LoadingButton } from "@mui/lab";
import {
    Box,
    Button,
    Chip,
    Divider,
    Icon,
    Stack,
    TextField,
} from "@mui/material";
import { ChangeEvent, useContext, useState } from "react";
import { SmsCampaignService, SmsTemplateDto } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import { SmsDescriptionHelper } from "../../../utils/SmsCountHelper";

// updated
export default function SaveSmsTemplateDialog(props: {
    templateAddedOrUpdated: (SmsTemplateDto) => void;
    template?: SmsTemplateDto;
}) {
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [template, setTemplate] = useState(props.template?.template ?? "");

    const { closeDialog } = useContext(DialogContext);

    const handleSaveTemplate = () => {
        setRequestInProgress(true);

        const request = props.template
            ? SmsCampaignService.updateSmsTemplate(props.template.id, "1", {
                  template: template,
              })
            : SmsCampaignService.addSmsTemplate("1", {
                  template: template,
              });

        request.then((r) => {
            setRequestInProgress(false);
            closeDialog();
            props.templateAddedOrUpdated(r);
        });
    };

    const addConstructorNamePlaceHolder = () => {
        const target = document.getElementById("template-text-area");
        target.focus();
        document.execCommand("insertText", false /*no UI*/, "{*}");
    };

    const handleMessageChange = (
        elem: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setTemplate(elem.target.value);
    };

    const charCount = template.length;
    const partCount = SmsDescriptionHelper.count(template);
    const isPersian = SmsDescriptionHelper.isPersian(template);

    return (
        <DialogContainer>
            <DialogHeader title="ذخیره پیش نویس جدید" />

            <Box sx={{ p: 2 }}>
                <TextField
                    multiline
                    rows={4}
                    className={"padding-bottom"}
                    id="template-text-area"
                    fullWidth
                    onChange={handleMessageChange}
                    value={template}
                    label="متن پیش نویس"
                />

                <Stack
                    direction="row"
                    justifyContent="space-between"
                    sx={{ pt: 1 }}
                    gap={1}
                >
                    <Chip
                        label={isPersian ? "فارسی" : "English"}
                        size="small"
                        color={isPersian ? "success" : "warning"}
                    />

                    <Chip size="small" label={`${charCount}  کاراکتر`} />

                    <Chip size="small" label={`${partCount}  پارت`} />

                    <Box sx={{ flexGrow: 1 }} />

                    <Button
                        onClick={addConstructorNamePlaceHolder}
                        size="small"
                        variant="outlined"
                        endIcon={<Icon>person_add</Icon>}
                    >
                        افزودن نام مخاطب
                    </Button>
                </Stack>

                <Divider sx={{ my: 2 }} />

                <LoadingButton
                    fullWidth
                    variant="contained"
                    onClick={handleSaveTemplate}
                    loading={requestInProgress}
                >
                    ذخیره پیش نویس
                </LoadingButton>
            </Box>
        </DialogContainer>
    );
}
